module.exports = __webpack_public_path__ + "static/images/cjzd_fxbg.bbdf3d7bc.png";